// Firebase core
import { initializeApp } from "firebase/app";

// Services you are using
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDVQ-i4TRdH9dw1pOi_R5aiuqAkjCn1CoU",
  authDomain: "check2-external.firebaseapp.com",
  projectId: "check2-external",
  storageBucket: "check2-external.firebasestorage.app",
  messagingSenderId: "347061754547",
  appId: "1:347061754547:web:9fab3bf706275557aeeec6",
};

// Init app
const app = initializeApp(firebaseConfig);

// Services
const firestore = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

// Providers
const googleProvider = new GoogleAuthProvider();


// Safer analytics setup
const analyticsPromise = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);

// Providers
const createGoogleProvider = () => {
  console.log("[Firebase Auth] Creating Google provider...");

  const provider = new GoogleAuthProvider();

  provider.addScope("email");
  provider.addScope("profile");

  provider.setCustomParameters({
    prompt: "select_account",
  });

  console.log(
    "[Firebase Auth] Google provider created with email/profile scope.",
  );

  return provider;
};


// Exports (match your SignIn usage)
export {
  app,
  firestore as dbAML,
  firestore as db,
  firestore,
  auth,
  analyticsPromise as analytics,
  createGoogleProvider,
  signInWithPopup,
  signOut,
};